import { createTextNode, SLATE_TEXT_FORMATS } from 'src/lib/slate';

/**
 * Create an "instruction" node for the Slate editor.
 * @param {PromptInstruction} instruction - instruction data
 * @returns {{type: SLATE_TEXT_FORMATS, data: PromptInstruction, children: {text: string}[]}}
 */
export const createInstructionNode = (instruction) => ({
  type: SLATE_TEXT_FORMATS.PROMPT_INSTRUCTION,
  data: instruction,
  children: [createTextNode(instruction.text)],
});
